import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { DefaultPage } from "@/components/default-page";

export const Route = createFileRoute("/hospital/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="">
      <DefaultPage tenantHeader="Hospital" />
    </div>
  );
}
